import { useParams, Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useSubscriptionInvoice } from '../../hooks/useSubscription';

function fmtVnd(n: number) { return new Intl.NumberFormat('vi-VN').format(n) + 'đ'; }
function fmtDate(iso: string) { return new Date(iso).toLocaleString('vi-VN'); }

export function SubscriptionInvoicePage() {
  const { t } = useTranslation('billing');
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useSubscriptionInvoice(id);

  if (isLoading) return <div className="p-6 text-surface-500">…</div>;
  if (error || !data) {
    return (
      <div className="p-6 max-w-md mx-auto text-red-700 bg-red-50 border border-red-200 rounded-md">
        {(error as Error | null)?.message ?? 'Không tìm thấy hoá đơn này.'}
      </div>
    );
  }

  if (data.status === 'EXPIRED') {
    return (
      <div className="p-6 max-w-md mx-auto">
        <p className="text-surface-700 mb-3">{t('invoice.expired')}</p>
        <Link to="/billing" className="text-brand-600 hover:underline">← {t('title')}</Link>
      </div>
    );
  }

  if (data.status === 'PAID') {
    return (
      <div className="p-6 max-w-md mx-auto">
        <p className="text-surface-700">{t('invoice.paid', { date: data.paidAt ? fmtDate(data.paidAt) : '' })}</p>
      </div>
    );
  }

  // PENDING
  return (
    <div className="p-6 max-w-md mx-auto space-y-5">
      <div>
        <Link to="/billing" className="text-brand-600 hover:underline text-[13px]">← {t('title')}</Link>
      </div>
      <p className="text-[14px] text-surface-700">{t('invoice.paymentInstructions')}</p>
      {data.qrUrl && (
        <img src={data.qrUrl} alt="VietQR" className="w-64 h-64 mx-auto" />
      )}
      <dl className="text-[13px] grid grid-cols-[120px_1fr] gap-y-2">
        <dt className="text-surface-500">{t('invoice.amount')}</dt>
        <dd className="font-semibold">{fmtVnd(data.amountVnd)}</dd>
        <dt className="text-surface-500">{t('invoice.ref')}</dt>
        <dd className="font-mono">{data.paymentRef}</dd>
        {data.bankInfo && (
          <>
            <dt className="text-surface-500">{t('invoice.accountNo')}</dt>
            <dd>{data.bankInfo.accountNo}</dd>
            <dt className="text-surface-500">{t('invoice.accountName')}</dt>
            <dd>{data.bankInfo.accountName}</dd>
          </>
        )}
      </dl>
      <p className="text-[12px] text-surface-500">{t('invoice.iPaidHint')}</p>
    </div>
  );
}
